import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import PrivateRoute from "@/components/admin/PrivateRoute";
import BookAnnouncement from "@/components/site/BookAnnouncement";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import AteliersPage from "@/pages/AteliersPage";
import ConstellationsPage from "@/pages/ConstellationsPage";
import CalendrierPage from "@/pages/CalendrierPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors theme="light" />
      <BrowserRouter>
        <AuthProvider>
          <BookAnnouncement />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/ateliers-constellations" element={<AteliersPage />} />
            <Route path="/constellations-en-groupe" element={<ConstellationsPage />} />
            <Route path="/calendrier-ateliers" element={<CalendrierPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminDashboardPage />
                </PrivateRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
